import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faRightFromBracket, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Topbar({ onMenuClick }) {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <header className="h-16 bg-white shadow-sm flex items-center justify-between px-6 sticky top-0 z-40">
        <div className="flex items-center justify-between w-full">
          <h1 className="font-heading font-bold text-xl text-primary tracking-tight">
            Admin <span className="text-gray-400 font-light">| Panel</span>
          </h1>

          <div className="flex items-center gap-4">
            {/* LOGOUT BUTTON (DESKTOP) */}
            <button
              onClick={() => setShowLogoutModal(true)}
              className="hidden md:flex items-center gap-2 group"
              title="Logout"
            >
              <span className="text-sm font-semibold text-gray-500 group-hover:text-red-600 transition-colors">Logout</span>
              <FontAwesomeIcon 
                icon={faRightFromBracket} 
                className="border-gray-200 border-2 text-gray-500 p-2.5 rounded-xl group-hover:border-red-500 group-hover:bg-red-500 group-hover:text-white transition-all duration-300" 
              />
            </button>

            {/* MOBILE MENU BUTTON */}
            <button
              onClick={onMenuClick}
              className="md:hidden p-2 text-xl text-gray-700 hover:bg-gray-100 rounded-lg transition"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
        </div>
      </header>

      {/* --- LOGOUT CONFIRMATION MODAL --- */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop (Back background) */}
          <div 
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setShowLogoutModal(false)}
          ></div>

          {/* Modal Content */}
          <div className="bg-white rounded-2xl p-6 shadow-2xl w-full max-w-sm relative z-10 transform transition-all animate-in fade-in zoom-in duration-200">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 text-2xl" />
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-2">Confirm Logout</h3>
              <p className="text-gray-500 mb-8">
                Are you sure you want to logout? You will need to login again to access the panel.
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => setShowLogoutModal(false)}
                  className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogout}
                  className="flex-1 px-4 py-2.5 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 shadow-lg shadow-red-200 transition"
                >
                  Yes, Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}